import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Modal from "react-responsive-modal"
import settings from "settings"
import _ from "lodash"
import { toast } from "react-toastify"
import ReactTable from "react-table"
import submitData from "helpers/submitData"
import submitDataAsync from "helpers/asyncSubmitData"
import axios from "axios"
import getData from "helpers/asyncSubmitData"
import ARCSubmitMaster from "containers/entry/arcEditMaster"
import ARCMasterHistory from "containers/modals/arcMasterHistory"
import ReactSelect from "components/ReactSelect"

class MasterArc extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			elevations: [],
			arc_review_notes: "",
			masterRejectionReason: "",
			masterApprovalComments: "",
			editModal: false,
			permRejectModal: false,
			columns: [
				{
					Header: "Image",
					accessor: "image",
				},
				{
					Header: "Name",
					accessor: "name",
				},
				{
					Header: "Masonry Percent",
					accessor: "masonry_percent",
				},
				{
					Header: "Roof Pitch",
					accessor: "roof_pitch",
				},
				{
					Header: "Total Height",
					accessor: "total_height",
				},
				{
					Header: "Min. Sq. Ft",
					accessor: "min_sqft",
				},
				{
					Header: "Max. Sq. Ft",
					accessor: "max_sqft",
				},
				...(this.props.payload.public.floorplan_classifications?.length
					? [
							{
								Header: "Style",
								accessor: "style",
								filterable: false,
								minWidth: 200,
							},
					  ]
					: []),
				{
					Header: "Notes",
					accessor: "notes",
					filterable: false,
					minWidth: 200,
				},
				{
					Header: "Accept",
					accessor: "accept",
					filterable: false,
				},
				{
					Header: "Reject",
					accessor: "reject",
					filterable: false,
				},
				{
					Header: "Rejection Reason (emailed to builder)",
					accessor: "reason",
					filterable: false,
					minWidth: 200,
				},
				{
					Header: "Delete Elevation",
					accessor: "delete",
					filterable: false,
				},
			],
			data: {},
			fullFloorplan: {},
			showHistory: false,
		}
	}

	componentDidMount() {
		this.init()
	}

	componentDidUpdate(prev) {
		if (!_.isEqual(this.props, prev)) {
			this.init()
		}
		return null
	}

	init = () => {
		this.buildComments()
		this.buildReasons()
		this.buildReviewNotes()
		this.buildElevations()
	}

	buildComments = async () => {
		try {
			if (this.props.data.id && this.props.open) {
				let resp = await getData("mainRetrieve", { action: "getFloorplan", id: this.props.data.id })
				if (resp.status === 200) {
					let f = _.findIndex(resp.data.arc_approved, { property: parseInt(this.props.data.property) })
					let masterApprovalComments = resp.data.arc_approved[f].approval_comments
					if (this.state.masterApprovalComments) masterApprovalComments = this.state.masterApprovalComments
					let masterRejectionReason = resp.data.arc_approved[f].reason
					if (this.state.masterRejectionReason) masterRejectionReason = this.state.masterRejectionReason
					if (f !== -1) {
						this.setState({
							masterApprovalComments,
							masterRejectionReason,
							fullFloorplan: resp.data,
						})
					}
				}
			}
		} catch (e) {
			console.log(e)
		}
	}

	buildClassifications = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplan_classifications, (v) => {
			ret.push({ label: v.name, value: v.id })
		})
		return ret
	}

	buildReviewNotes = () => {
		try {
			let val = _.get(this.props, `data.arc_review_notes`)
			if (val) {
				this.setState({ arc_review_notes: this.props.data.arc_review_notes })
			} else {
				this.setState({ arc_review_notes: "" })
			}
		} catch (e) {
			console.log(e)
		}
	}

	buildReasons = () => {
		try {
			let row = _.find(this.props.data.arc_approved, { property: this.props.data.property })
			if (!row) throw `Cannot find row.`
			let f = {
				masterRejectionReason: "",
				masterApprovalComments: "",
			}
			if (row.rejection_reason) {
				f.masterRejectionReason = row.rejection_reason
			}
			if (row.approval_comments) {
				f.masterApprovalComments = row.approval_comments
			}
			this.setState({ ...f }, () => {
				//console.log(this.state)
			})
		} catch (e) {
			console.log(e)
		}
	}

	buildElevations = () => {
		let ret = []
		_.forEach(this.props.payload.public.elevations, (v, k) => {
			if (this.props.data.id == v.floorplan && this.props.data.property == v.property) {
				let status = null
				if (v.approval_status == 1) status = true
				if (v.approval_status == 0) status = false
				let style = _.find(this.props.payload.public.floorplan_classifications, { id: v.style })
				ret.push({
					image: v.image,
					id: v.id,
					name: v.name,
					min_sqft: v.min_sqft,
					max_sqft: v.max_sqft,
					masonry_percent: v.masonry_percent,
					roof_pitch: v.roof_pitch,
					total_height: v.total_height,
					status,
					style: v.style,
					notes: v.notes,
					reason: v.rejection_reason,
				})
			}
		})
		this.setState({ elevations: ret }, () => {
			//console.log(this.state.elevations)
		})
	}

	deleteElevation = (id) => {
		let data = {
			action: "arcDeleteElevation",
			id,
		}
		submitData("mainIngest", data)
			.then((data) => {
				toast.success(data.message)
				this.props.getPayload()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	buildElevationsTable = (f) => {
		let ret = []
		_.forEach(this.state.elevations, (v, k) => {
			let acceptStatus = v.status === true ? true : false
			let rejectStatus = v.status === false ? true : false
			ret.push({
				...v,
				accept: (
					<input
						name={k}
						key={`accept-${k}`}
						type="radio"
						checked={acceptStatus}
						onChange={() => {
							let elevations = _.clone(this.state.elevations)
							elevations[k].status = true
							this.setState({ elevations })
						}}
					/>
				),
				reject: (
					<input
						name={k}
						key={`reject-${k}`}
						type="radio"
						checked={rejectStatus}
						onChange={() => {
							let elevations = _.clone(this.state.elevations)
							elevations[k].status = false
							this.setState({ elevations })
						}}
					/>
				),
				reason: (
					<textarea
						name={k}
						key={`reason-${k}`}
						value={this.state.elevations[k].reason}
						onChange={(val) => {
							let elevations = _.clone(this.state.elevations)
							elevations[k].reason = val.target.value
							this.setState({ elevations })
						}}></textarea>
				),
				style: (
					<ReactSelect
						name={`style-${k}`}
						key={`style-${k}`}
						options={this.buildClassifications()}
						value={this.state.elevations[k].style}
						onChange={(name, value) => {
							let elevations = _.clone(this.state.elevations)
							elevations[k].style = value
							this.setState({ elevations })
						}}
						onBlur={() => {}}
						clearable={true}
						placeholder="Select Style"
					/>
				),
				notes: (
					<textarea
						name={k}
						key={`notes-${k}`}
						value={this.state.elevations[k].notes}
						onChange={(val) => {
							let elevations = _.clone(this.state.elevations)
							elevations[k].notes = val.target.value
							this.setState({ elevations })
						}}></textarea>
				),
				delete: (
					<span
						className="text-red-500 flex items-center justify-center cursor-pointer"
						onClick={() => this.deleteElevation(v.id)}>
						<i className="fa fa-minus-circle"></i>
					</span>
				),
				image: v.image ? (
					<div>
						<a href={`${settings.s3}/${v.image}`} target="_blank">
							<img src={`${settings.s3}/${v.image}`} />
						</a>
					</div>
				) : null,
			})
		})

		return ret
	}

	answerMasterPlan = (status) => {
		let data = {
			status,
			property: this.props.data.property,
			masterRejectionReason: this.state.masterRejectionReason,
			masterApprovalComments: this.state.masterApprovalComments,
			id: this.props.data.id,
		}
		submitData("arcAnswerMasterPlan", data)
			.then((data) => {
				toast.success(data.message)
				//this.props.getPayload()
				//this.props.onClose()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	answerElevations = (status) => {
		let data = {
			elevations: this.state.elevations,
			property: this.props.data.property,
			floorplan: this.props.data.id,
		}
		submitData("arcAnswerElevations", data)
			.then((data) => {
				toast.success(data.message)
				//this.props.getPayload()
				//this.props.onClose()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	updateReviewerNotes = () => {
		let data = {
			arc_review_notes: this.state.arc_review_notes,
			floorplan: this.props.data.id,
			action: "updateReviewerNotes",
		}
		submitData("mainIngest", data)
			.then((data) => {
				toast.success(data.message)
				this.props.getPayload()
				this.props.onClose()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	deactivatePlan = () => {
		let d = {
			id: this.props.data.id,
		}
		submitData("deactivateFloorplan", d)
			.then((data) => {
				toast.success(data.message)
				this.props.getPayload()
				this.props.onClose()
			})
			.catch((e) => {
				toast.error(e)
			})
	}

	permRejectModal = () => {
		return (
			<div
				className="portal__noActivityButton"
				onClick={() => {
					this.setState({ permRejectModal: true })
				}}>
				Report No Weekly Activity
			</div>
		)
	}

	saveComments = async () => {
		let f = {
			approval_comments: this.state.masterApprovalComments,
			reason: this.state.masterRejectionReason,
			id: this.props.data.id,
			property: this.props?.data?.property,
			action: "arcMasterUpdateNotes",
		}

		let data = await submitDataAsync("mainIngest", f)
		toast.success(data.message)
		//this.props.getPayload()
	}

	render() {
		let builder = _.find(this.props.payload.public.builders, { id: parseInt(this.props.data.builder) })
		let property = _.find(this.props.payload.public.properties, { id: parseInt(this.props.data.property) })
		let types = ""
		if (this.props.data.lot_types && typeof this.props.data.lot_types == "object") {
			_.forEach(this.props.data.lot_types, (v) => {
				if (this.props.data.property == v.property) {
					let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
					if (type) types += `${type.name}, `
				}
			})
			types = _.trim(types, ", ")
		}
		let filePath = false
		if (this.props.data.arc_file && typeof this.props.data.arc_file == "object") {
			_.forEach(this.props.data.arc_file, (v) => {
				if (v.property == this.props.data.property) {
					filePath = v.file
				}
			})
		}
		let comments = ""
		let commentLookup = _.find(this.props.data.arc_builder_comments, { property: this.props.data.property })
		if (commentLookup) comments = commentLookup.comments
		//? Clasifications
		let classifications = ""
		if (this.props.payload.public.floorplan_classifications?.length) {
			let arr = []
			_.forEach(this.props.data.classifications, (v) => {
				let c = _.find(this.props.payload.public.floorplan_classifications, { id: v })
				if (c) arr.push(c.name)
			})
			classifications = arr.join(", ")
		}
		let approvalNotesFile = _.find(this.state.fullFloorplan.arc_reviewer_files, {
			property: String(this.props.data.property),
			type: "approval",
		})
		let rejectionNotesFile = _.find(this.state.fullFloorplan.arc_reviewer_files, {
			property: String(this.props.data.property),
			type: "rejection",
		})
		return (
			<div>
				<Modal open={this.props.open} onClose={this.props.onClose} center classNames={{ modal: "arcModal" }}>
					<div className="flex justify-between w-full pt-16">
						<div>
							<h2 className="p-0">Master Plan Submission: {this.props.data.name}</h2>
							<div
								className="btn btn--square ml-4 text-xs"
								onClick={() => {
									this.setState({ editModal: true })
								}}>
								Edit Submission
							</div>
						</div>
						<div className="flex">
							<div
								className="flex items-center"
								onClick={() => {
									this.setState({ showHistory: true })
								}}>
								<a className="bg-blue px-2 py-1 rounded-lg text-xs text-white cursor-pointer">
									View History
								</a>
							</div>
							<div
								className="flex items-center ml-2"
								onClick={() => {
									this.setState({ permRejectModal: true })
								}}>
								<a className="bg-red-500 px-2 py-1 rounded-lg text-xs text-white cursor-pointer">
									Deactivate Plan
								</a>
							</div>
						</div>
					</div>
					<table className="dataTable text-sm">
						<thead>
							<tr>
								<th>Name</th>
								<th>Number</th>
								<th>Builder</th>
								<th>Property</th>
								<th>Stories</th>
								<th>Lot Types</th>
								<th>Width Feet</th>
								<th>Width Inches</th>
								<th>Sqft</th>
								<th>Full Baths</th>
								<th>Half Baths</th>
								<th>Garage</th>
								<th>Beds</th>
								{this.props.data.roof_pitch ? <th>Pitch</th> : null}
								{this.props.data.height ? <th>Height</th> : null}
								{this.props.data.masonry_percent ? <th>Masonry %</th> : null}
								{this.props.payload.public.floorplan_classifications?.length ? <th>Class</th> : null}
								<th>File</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{this.props.data.name}</td>
								<td>{this.props.data.plan_number}</td>
								<td>{(builder && builder.name) || ""}</td>
								<td>{(property && property.name) || ""}</td>
								<td>{this.props.data.stories}</td>
								<td>{types}</td>
								<td>{this.props.data.base_width_feet}</td>
								<td>{this.props.data.base_width_inches}</td>
								<td>{this.props.data.sqft}</td>
								<td>{this.props.data.full_baths}</td>
								<td>{this.props.data.half_baths}</td>
								<td>{this.props.data.garage}</td>
								<td>{this.props.data.beds}</td>
								{this.props.data.roof_pitch ? <td>{this.props.data.roof_pitch}</td> : null}
								{this.props.data.height ? <td>{this.props.data.height}</td> : null}
								{this.props.data.masonry_percent ? <td>{this.props.data.masonry_percent}</td> : null}
								{this.props.payload.public.floorplan_classifications?.length ? (
									<td>{classifications}</td>
								) : null}
								<td>
									{filePath ? (
										<a className="btn-square" href={`${settings.s3}${filePath}`} target="_blank">
											View Plan
										</a>
									) : (
										<span style={{ fontSize: 12 }}>No File Loaded</span>
									)}
								</td>
							</tr>
						</tbody>
					</table>

					<div style={{ marginTop: 20 }}>
						<label htmlFor="base_width_inches">Comments</label>
						{comments}
					</div>

					<div className="arcModal__approvalBox">
						<div>
							<div className="flex justify-between items-end">
								<div className="border border-dashed border-neutral-400 px-2 py-2 mb-1 inline-block">
									<p className="text-sm">Attach Approval File</p>
									{approvalNotesFile ? (
										<a
											href={`${settings.s3}/${approvalNotesFile.file}`}
											target="_blank"
											className="text-xs font-bold text-blue block my-1">
											View Current File
										</a>
									) : null}
									<input
										name="approval_file"
										type="file"
										id="approval_file"
										className="noBorder"
										onChange={async (event) => {
											try {
												let file = event.currentTarget.files[0]
												const fd = new FormData()
												fd.append("approval_file", file)
												fd.append("type", "approval")
												fd.append("floorplan", this.props.data.id)
												fd.append("property", this.props.data.property)
												const response = await axios.post(
													`${settings.ep}/arcStoreMasterReviewerFile`,
													fd,
													{
														headers: {
															"Content-Type": "multipart/form-data",
															Authorization: `Bearer ${localStorage.getItem("user")}`,
														},
													}
												)
												this.buildComments() // This is just to get the current file to show up
												toast.success("File uploaded successfully")
											} catch (error) {
												console.error("Error uploading file:", error)
											}
										}}
									/>
								</div>
								<div className="">
									<span
										className="py-1 px-2 border border-dashed border-slate-400 text-xs cursor-pointer hover:bg-blue transition duration-200 hover:text-white"
										onClick={() => this.saveComments()}>
										<i className="fas fa-cloud-download" style={{ marginRight: 4 }} />
										Save Comments
									</span>
								</div>
							</div>
							<p>Approval Comments</p>
							<textarea
								value={this.state.masterApprovalComments}
								onChange={(v) => this.setState({ masterApprovalComments: v.target.value })}></textarea>
							<div className="arcModal__approve" onClick={() => this.answerMasterPlan(true)}>
								Approve
							</div>
						</div>
						<div className="arcModal__rejectionBox ml-3">
							<div className="border border-dashed border-neutral-400 px-2 py-2 mb-1 inline-block">
								<p className="text-sm">Attach Rejection File</p>
								{rejectionNotesFile ? (
									<a
										href={`${settings.s3}/${rejectionNotesFile.file}`}
										target="_blank"
										className="text-xs font-bold text-blue block my-1">
										View Current File
									</a>
								) : null}
								<input
									name="rejection_file"
									type="file"
									id="rejection_file"
									className="noBorder"
									onChange={async (event) => {
										try {
											let file = event.currentTarget.files[0]
											const fd = new FormData()
											fd.append("approval_file", file)
											fd.append("type", "rejection")
											fd.append("floorplan", this.props.data.id)
											fd.append("property", this.props.data.property)
											const response = await axios.post(
												`${settings.ep}/arcStoreMasterReviewerFile`,
												fd,
												{
													headers: {
														"Content-Type": "multipart/form-data",
														Authorization: `Bearer ${localStorage.getItem("user")}`,
													},
												}
											)
											toast.success("File uploaded successfully")
										} catch (error) {
											console.error("Error uploading file:", error)
										}
									}}
								/>
							</div>
							<p>Rejection Reason</p>
							<textarea
								onChange={(v) => this.setState({ masterRejectionReason: v.target.value })}
								value={this.state.masterRejectionReason}></textarea>
							<div className="arcModal__rejection" onClick={() => this.answerMasterPlan(false)}>
								Reject
							</div>
						</div>
					</div>
					<div className="py-12 bg-gray-50 my-12 px-4 border-2 border-gray-600">
						<h3>Elevations</h3>
						<ReactTable
							data={this.buildElevationsTable()}
							columns={this.state.columns}
							defaultPageSize={5}
							loadingText=""
							className="showControls"
							onSortedChange={() => {
								this.forceUpdate()
							}}
						/>
						<div>
							<span className="squareButton" onClick={() => this.answerElevations()}>
								Submit Elevations
							</span>
						</div>
					</div>
					<h3 style={{ marginTop: 75 }}>Reviewer Notes</h3>
					<textarea
						value={this.state.arc_review_notes}
						onChange={(v) => this.setState({ arc_review_notes: v.target.value })}></textarea>
					<div style={{ marginTop: 25 }}>
						<span className="squareButton" onClick={() => this.updateReviewerNotes()}>
							Submit Notes
						</span>
					</div>
				</Modal>
				<Modal
					classNames={{ modal: "modalForm" }}
					open={this.state.permRejectModal}
					onClose={() => this.setState({ permRejectModal: false })}
					center>
					<div className="noActivity">
						<p>
							Are you sure you want to <strong>permanently</strong> remove this floorplan?
						</p>
						<p>
							<span className="btn" onClick={() => this.deactivatePlan()}>
								CONFIRM
							</span>
						</p>
					</div>
				</Modal>
				<Modal
					classNames={{ modal: "modalForm" }}
					open={this.state.editModal}
					onClose={() => {
						this.setState({ editModal: false })
					}}
					center>
					<div className="">
						<ARCSubmitMaster
							admin={true}
							fullPlan={this.props.data}
							hideExport={true}
							onClose={() => {
								this.setState({ editModal: false })
								this.props.updateFlare()
							}}
						/>
					</div>
				</Modal>
				<ARCMasterHistory
					showHistory={this.state.showHistory}
					data={this.state.fullFloorplan}
					onClose={() => {
						this.setState({ showHistory: false })
					}}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MasterArc)
